module.exports = __webpack_public_path__ + "img/sign-5.e6d535a0.gif";